var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vacation"},[_c('span',[_c('span',{staticClass:"m-r-1"},[_vm._v("🏖")]),_vm._v("오늘은 쉬는 날이에요. 양해 부탁드려요! 🏝")])])}]

export { render, staticRenderFns }